import { Component, OnInit } from '@angular/core';
import { Breadcrumb, GenerateTablePageEvent, GenerateTablePagination } from '../shared/components';
import { Demandante, Dio, DioFilters, StatusAfericaoDIO, StatusExecucaoDIO, statusAfericao, statusExecucao } from './dio.model';
import { DioService } from './dio.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchErr, getBadgeColor } from '../shared/utils';
import { Contrato } from '../contrato/contrato.model';
import { Servico } from 'src/app/servico';
import { Alocacao } from '../contrato/view-contrato/alocacao/alocacao.model';
import { Condutor, CondutorService } from 'src/app/condutor';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';
import { forkJoin, of } from 'rxjs';
import { Orgao, OrgaoService } from 'src/app/localidade';
import { DemandanteService } from './demandante.service';
import { Equipamento } from 'src/app/equipamento';
import { isEmpty, mapValues, pickBy } from 'lodash-es';
import { AuthService, RolesEnum } from 'src/app/core';
import { AlocacaoService, ContratoService } from 'src/app/contrato';
import { NgxMaskPipe } from 'ngx-mask';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UsuarioResponse } from '../usuario';
import dayjs from 'dayjs';
import { MatDialog } from '@angular/material/dialog';
import { CancelarDioComponent } from './view-dio/cancelar-dio/cancelar-dio.component';
import { AssinaturaDioComponent } from './view-dio/assinatura-dio/assinatura-dio.component';

@Component({
    selector: 'dio',
    templateUrl: './dio.component.html',
    providers: [NgxMaskPipe],
    standalone: false
})
export class DioComponent implements OnInit {

    loading = { main: true, filter: false };
    toggleFilters: boolean;
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 }
    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Diários de Operação' },
    ]

    dataSource: any[];
    filters = {} as DioFilters | any;

    beneficiarias: Beneficiaria[];
    condutores: Condutor[];
    contratos: Contrato[];
    demandantes: Demandante[];
    orgaos: Orgao[];
    alocacoes: Alocacao[];

    orgao: Orgao;
    user: UsuarioResponse;
    currentRole: string;
    currentBeneficiaria = {} as Beneficiaria;
    currentStatusExecucao: string;

    titlePage: string;
    showFields = { status: true, BenConEqui: true }

    statusExecucao = statusExecucao;
    statusAfericao = statusAfericao;
    getBadgeColor = getBadgeColor;

    constructor(
        private authService: AuthService,
        private condutorService: CondutorService,
        private contratoService: ContratoService,
        private demandanteService: DemandanteService,
        private dioService: DioService,
        private beneficiariaService: BeneficiariaService,
        private alocacaoService: AlocacaoService,
        private orgaoService: OrgaoService,
        private snackBar: MatSnackBar,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private dialog: MatDialog,
    ) { }

    ngOnInit() {
        this.user = this.authService.user;
        this.currentRole = this.authService.user.realm_access ? this.authService.user.realm_access.roles[0] : '';
        this.getQueryParam();

        this.activatedRoute.params.subscribe((params: Params) => {
            this.currentStatusExecucao = params['statusExecucao'];
            this.showFields.status = !this.currentStatusExecucao;
            this.titlePage =
                this.currentStatusExecucao === 'atesto' ? 'Diários de Operação - Pendentes de Atesto' :
                this.currentStatusExecucao === 'validacao' ? 'Diários de Operação - Pendentes de Validação' :
                this.currentStatusExecucao === 'afericao' ? 'Diários de Operação - Pendentes de Aferição' :                
                'Diários de Operação';

            // Recarregar dados quando os parâmetros mudarem
            this.loadData();
        });
    }

    private loadData() {
        if (this.currentRole === RolesEnum.CONTRATADO_ADM) {
            this.beneficiariaService.getBeneficiariaByUserVirtualId(this.authService.user.sub).subscribe((beneficiaria) => {
                this.filters.beneficiaria = beneficiaria.data[0].id;
                this.currentBeneficiaria = beneficiaria.data[0];
                this.getAllResources(beneficiaria.data[0].id);
                this.search();
            });
        } else if (this.currentRole === RolesEnum.AFERIDOR) {
            if (!this.currentStatusExecucao) {
                this.router.navigate(['/pendencias/afericao']);
            }
            this.getAllResources();
            this.search();
        } else {
            this.getAllResources();
            this.search();
        }
    }

    search(pageEvent?: GenerateTablePageEvent) {
        this.loading.main = true;
        this.pagination.current = pageEvent ? pageEvent.current : this.pagination.current
        this.pagination.pageSize = pageEvent ? pageEvent.pageSize : this.pagination.pageSize

        const filters = { ...this.filters };
        console.log('filters: ', filters);

        filters.startCreatedAt = filters.startCreatedAt ? `${dayjs(filters.startCreatedAt).format('YYYY-MM-DD')}T00:00:00` : filters.startCreatedAt;
        filters.endCreatedAt = filters.endCreatedAt ? `${dayjs(filters.endCreatedAt).format('YYYY-MM-DD')}T23:59:59` : filters.endCreatedAt;
        filters.startDataPeriodoInicioOperacao = filters.startDataPeriodoInicioOperacao ? `${dayjs(filters.startDataPeriodoInicioOperacao).format('YYYY-MM-DD')}` : filters.startDataPeriodoInicioOperacao;
        filters.endDataPeriodoInicioOperacao = filters.endDataPeriodoInicioOperacao ? `${dayjs(filters.endDataPeriodoInicioOperacao).format('YYYY-MM-DD')}` : filters.endDataPeriodoInicioOperacao;        
        filters.endDataPeriodoFimOperacao = filters.endDataPeriodoFimOperacao ? `${dayjs(filters.endDataPeriodoFimOperacao).format('YYYY-MM-DD')}` : filters.endDataPeriodoFimOperacao;
        filters.startDateLimite = filters.startDateLimite ? `${dayjs(filters.startDateLimite).format('YYYY-MM-DD')}T00:00:00` : filters.startDateLimite;
        filters.endDateLimite = filters.endDateLimite ? `${dayjs(filters.endDateLimite).format('YYYY-MM-DD')}T23:59:59` : filters.endDateLimite;

        if (this.currentStatusExecucao === 'atesto') {
            filters.statusExecucao = StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO;
        } else if (this.currentStatusExecucao === 'validacao') {
            filters.statusExecucao = StatusExecucaoDIO.AGUARDANDO_FISCAL;
        } else if (this.currentStatusExecucao === 'afericao') {
            filters.statusExecucao = StatusExecucaoDIO.EXECUTADA;
            filters.statusAfericao = StatusAfericaoDIO.AGUARDANDO_AFERICAO
            filters.orderBy = 'dataDisponibilizacao';
            if (this.currentRole === RolesEnum.AFERIDOR) {
                filters.aferidor = this.user.id;
            }
        }

        filters.startDataInicioExecucao = undefined;
        filters.endDataInicioExecucao = undefined;

        this.getAll(filters);
    }

    getAll(filters: DioFilters) {
        this.ajustarBeneficiariaSelecionada();
        this.ajustarContratoSelecionado();
        this.ajustarOrgaoSelecionado();
        this.ajustarEquipamentoSelecionado();

        this.dioService.getAllByParametersV2<Dio>(this.pagination.current, this.pagination.pageSize, pickBy(filters)).subscribe({
            next: (res) => {
                this.dataSource = res.data.map((data) => {

                    if (this.currentStatusExecucao === 'afericao') {
                        if (data?.dataDisponibilizacao) {
                            const alredyTenDays = dayjs(new Date()).diff(dayjs(data?.dataDisponibilizacao), 'days');
                            return {
                                ...this.buildResponseV2(data),
                                alreadyTenDays: alredyTenDays >= 10,
                            }
                        }
                    }

                    return this.buildResponseV2(data)
                });
                this.pagination.total = res.total;
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.main = false);
    }

    buildResponse(data: Dio) {
        const demandante = data.demandante as Demandante;
        const servico = data.servico as Servico;
        const alocacao = data.alocacao as unknown as Alocacao;
        const contrato = data.contrato as Contrato;
        const condutor = data.condutor as Condutor;
        const equipamento = alocacao?.equipamento as Equipamento;
        const beneficiaria = contrato.beneficiaria as Beneficiaria;

        return {
            ...data,
            demandanteNome: demandante?.nome,
            servicoNome: servico?.titulo,
            contratoNome: contrato?.nome,
            alocacaoCode: alocacao && alocacao?.codigo,
            equipamentoNome: equipamento && `${alocacao.codigo} (${equipamento?.placa})`,
            beneficiariaNome: beneficiaria && beneficiaria?.nome,
            condutorNome: (condutor?.firstName && condutor?.lastName) ? `${condutor?.firstName} ${condutor?.lastName}` : null,
            dataLimiteExecucao: dayjs(data.dataLimiteExecucao).format('DD/MM/YYYY HH:mm:ss'),
            created_at: dayjs(data.created_at).format('DD/MM/YYYY HH:mm:ss'),
        }
    }

    buildResponseV2(data: any) {
        return {
            ...data,
            equipamentoNome: data.equipamentoPlaca && `${data.alocacaoCodigo} (${data.equipamentoPlaca})`,
            dataLimiteExecucao: dayjs(data.dataLimiteExecucao).format('DD/MM/YYYY HH:mm:ss'),
            created_at: dayjs(data.created_at).format('DD/MM/YYYY HH:mm:ss'),            
        }
    }

    getAllResources(beneficiaria?: string) {
        this.loading.filter = true;
        const contratoRequest = beneficiaria ? this.contratoService.getAllByBeneficiaria(beneficiaria) : this.contratoService.getAll<Contrato>();
        const alocacaoRequest = this.alocacaoService.getAll<Alocacao>();
        const orgaoRequest = this.orgaoService.getAll<Orgao>();
        const demandanteRequest = this.demandanteService.getAll<Demandante>();
        const beneficiariaRequest = this.beneficiariaService.getAll<Beneficiaria>();
        const orgaoUsarioRequest = this.user.id && (this.currentRole === RolesEnum.FUNCIONARIO || this.currentRole === RolesEnum.FISCAL)
        ? this.orgaoService.getByUsuario<Orgao>(this.user.id)
        : of([]);
        const condutorRequest = beneficiaria ? this.condutorService.getAllByBeneficiaria(beneficiaria) : this.condutorService.getAll<Condutor>();

        forkJoin([contratoRequest, orgaoRequest, demandanteRequest, orgaoUsarioRequest, alocacaoRequest, condutorRequest, beneficiariaRequest]).subscribe({
            next: ([resContrato, resOrgao, resDemandante, resOrgaosUsuarios, resAlocacao, resCondutor, resBeneficiaria]) => {
                this.contratos = resContrato.data;
                this.ajustarContratoSelecionado();

                this.orgaos = resOrgao.data;
                this.ajustarOrgaoSelecionado();
                
                this.demandantes = resDemandante.data;
                
                this.alocacoes = resAlocacao.data;
                this.ajustarEquipamentoSelecionado();

                this.beneficiarias = resBeneficiaria.data;
                this.ajustarBeneficiariaSelecionada();

                const orgaosUsuarios = resOrgaosUsuarios;
                if (orgaosUsuarios.length > 0) {
                    this.orgaos = orgaosUsuarios;
                    this.showFields.BenConEqui = false;
                }

                this.condutores = resCondutor.data;
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading.filter = false);
    }

    searchCondutor(term: string, item: Condutor) {
        term = term.toLocaleLowerCase();
        return item.nome.toLocaleLowerCase().indexOf(term) > -1;            
    }

    searchEquipamento(term: string, item: Alocacao) {
        term = term?.toLocaleLowerCase();
        return item.codigo && item?.codigo.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.equipamento.placa && item?.equipamento.placa.toLocaleLowerCase().indexOf(term) > -1 ||
            item?.equipamento.modelo && item?.equipamento.modelo.toLocaleLowerCase().indexOf(term) > -1;
    }

    searchFn(term: string, item: any) {
        term = term.toLocaleLowerCase();
        return item.nome.toLocaleLowerCase().indexOf(term) > -1;
    }

    compareWith(item: any, selected: any) {
        return item && selected && item.id == selected.id;
    }

    showCreateDio() {
        const rolesNotAllowed = [
            RolesEnum.CONTRATADO_ADM.toString(),
            RolesEnum.AFERIDOR.toString(),
            RolesEnum.COORDENADOR.toString(),
        ];

        return !(rolesNotAllowed.includes(this.currentRole))
            && this.currentRole !== RolesEnum.FUNCIONARIO
            && this.currentRole !== RolesEnum.FISCAL
    }

    private setQueryParam() {
        let queryParams = {} as Params;
        //mapValues(this.filters, (value, key) => queryParams = value ? { ...queryParams, ...{ [key]: value } } : queryParams)

        const urlTree = this.router.createUrlTree([], { queryParams, queryParamsHandling: '' });
        this.router.navigateByUrl(urlTree);
    }

    private getQueryParam() {
        //mapValues(this.activatedRoute.snapshot.queryParams, (value, key) => this.filters[key] = value);

        this.toggleFilters = !isEmpty(this.filters)
    }

    /**
     * This function helps performance when angular show a list
     * 
     * @param index 
     * @param item 
     * @returns 
     */
    trackByFn(index: number, item: any): any {
        return item.id;
    }

    openMap(dio: Dio){        
        const urlTree = this.router.createUrlTree(['/dio', dio.id, 'mapa']);
        window.open(String(urlTree), '_blank');
        //this.router.navigateByUrl(urlTree);         
    }

    visualizarDio(dio: Dio){
        this.router.navigate(['/dio/' + dio.id + '/visualizar']);
    }

    aproveDio(dio: Dio){
        console.log('aprovar dio ', dio.numero);
        const dialogRef = this.dialog.open(AssinaturaDioComponent, {
            data: {
                dioId: dio.id,
                dioNumber: dio.numero,
                statusExecucao: dio.statusExecucao
            }, width: '500px'
        });

        dialogRef.beforeClosed().subscribe((result) => { 
            this.dataSource = this.dataSource.filter(d => d.id !== dio.id);
        });
    }

    aferirDio(dio: Dio){
        this.router.navigate(['/dio/' + dio.id + '/aferir']);
    }

    cancelDio(dio: Dio){        
        const dialogRef = this.dialog.open(CancelarDioComponent, { data: { dio } });
        
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                console.log('DIO cancelada removida da lista: ', dio.numero);
                this.dataSource = this.dataSource.filter(d => d.id !== dio.id);    
            }
        });
    }   

    podeAprovarDio(dio: any) {
        const statusRole = dio.statusExecucao?.substring(dio.statusExecucao?.indexOf('_') + 1)!;
        return (
            (this.currentRole === RolesEnum.GESTAO_ADMIN || this.currentRole === RolesEnum.FUNCIONARIO || this.currentRole === RolesEnum.FISCAL) &&
            (statusRole == RolesEnum.FUNCIONARIO || statusRole == RolesEnum.FISCAL)
        ) || (dio.statusExecucao === StatusExecucaoDIO.CANCELADA && this.currentRole == RolesEnum.FISCAL);
    }

    podeAferirDio(dio: any){
        const canAferirDio = [
            RolesEnum.AFERIDOR.toString(), 
            RolesEnum.COORDENADOR.toString(), 
            RolesEnum.GESTAO_ADMIN.toString(),
        ];

        return canAferirDio.includes(this.currentRole) && 
                dio.statusAfericao && dio.statusAfericao === StatusAfericaoDIO.AGUARDANDO_AFERICAO &&
                dio.statusExecucao && dio.statusExecucao !== StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO;

    }

    /**
     * 
     * Regras definidas em https://trello.com/c/Q8eqQTcY/1299-1-ocultar-o-atalho-do-bot%C3%A3o-de-cancelar-um-dio-para-os-perfis-de-aferidor-e-coordenador
     * 
     */
    podeCancelarDio(dio: any){
        if(this.currentRole === RolesEnum.EMISSOR){
            return dio.statusExecucao === StatusExecucaoDIO.AGUARDANDO_EXECUCAO;
        }

        const perfilPodeCancelarDio = [
            RolesEnum.GESTAO_ADMIN.toString(),
            RolesEnum.FUNCIONARIO.toString(),
            RolesEnum.FISCAL.toString(),            
        ]

        const statusPodeCancelarDio = [
            StatusExecucaoDIO.AGUARDANDO_FUNCIONARIO.toString(), 
            StatusExecucaoDIO.AGUARDANDO_FISCAL.toString(),
            StatusExecucaoDIO.AGUARDANDO_EXECUCAO.toString(),            
        ];

        if(dio.statusExecucao === StatusExecucaoDIO.CANCELADA && this.hasUserSomeRole([RolesEnum.GESTAO_ADMIN, RolesEnum.AFERIDOR])){
            return true;
        }
        
        return perfilPodeCancelarDio.includes(this.currentRole) && statusPodeCancelarDio.includes(dio.statusExecucao);
    }

    podeExibirBotaoMapa(dio: any){
        const podeVerMapa = [
            RolesEnum.GESTAO_ADMIN.toString(), 
            RolesEnum.COORDENADOR.toString(),
            RolesEnum.FUNCIONARIO.toString(),
            RolesEnum.AFERIDOR.toString(),
            RolesEnum.FISCAL.toString()
        ];

        return podeVerMapa.includes(this.currentRole) && dio.statusExecucao !== StatusExecucaoDIO.AGUARDANDO_EXECUCAO;
    }    

    hasUserSomeRole(roles: string[]) {
        return roles.includes(this.currentRole);
    }

    podeExibirStatusAfericao(dio: Dio) {
        const statusExecucaoExibeAfericao = [
            StatusExecucaoDIO.AGUARDANDO_FISCAL,     
            StatusExecucaoDIO.EXPIRADA,
        ];

        return dio.statusExecucao && statusExecucaoExibeAfericao.includes(dio.statusExecucao);
    }

    setBeneficiaria(beneficiaria: Beneficiaria) {                
        if(beneficiaria && beneficiaria.id) {
            this.loading.filter = true;            

            localStorage.setItem('beneficiariaSelecionada', beneficiaria.id);

            forkJoin([
                this.contratoService.getAllByBeneficiaria(beneficiaria.id, false),
                this.condutorService.getAllByBeneficiaria(beneficiaria.id)
            ]).subscribe({
                next: ([resContrato, resCondutor]) => {
                    this.loading.filter = false;
                    this.contratos = resContrato.data;
                    this.condutores = resCondutor.data;

                    this.filters.contrato = null;
                    this.filters.alocacao = null;
                },
                error: () => {
                    this.loading.filter = false;
                }
            });
        } else {
            localStorage.removeItem('beneficiariaSelecionada');
        }
    }

    setEquipamento(equipamento: Alocacao) {
        if(equipamento && equipamento.id) {
            localStorage.setItem('equipamentoSelecionado', equipamento.id);
        } else {
            localStorage.removeItem('equipamentoSelecionado');
        }
    }

    setOrgao(orgao: Orgao) {
        if(orgao && orgao.id) {
            localStorage.setItem('orgaoSelecionado', orgao.id);
        } else {
            localStorage.removeItem('orgaoSelecionado');
        }
    }

    setContrato(contrato: Contrato) {
        if(contrato && contrato.id) {
            this.loading.filter = true;

            localStorage.setItem('contratoSelecionado', contrato.id);

            this.alocacaoService.getAllByContrato(contrato.id).subscribe({
                next: (res) => {
                    this.loading.filter = false;
                    this.alocacoes = res.data;
                    this.filters.alocacao = null;
                },
                error: () => {
                    this.loading.filter = false;
                }
            });
        } else {
            localStorage.removeItem('contratoSelecionado');
        }
    }

    ajustarBeneficiariaSelecionada() {
        const beneficiariaId = localStorage.getItem('beneficiariaSelecionada');
        if (beneficiariaId && this.beneficiarias) {
            const beneficiariaObj = this.beneficiarias.find(b => b.id == beneficiariaId);
            if (beneficiariaObj) {
                this.filters.beneficiaria = beneficiariaObj;
            }
        }
    }

    ajustarOrgaoSelecionado(){
        const orgaoId = localStorage.getItem('orgaoSelecionado');
        if (orgaoId && this.orgaos) {
            const orgaoObj = this.orgaos.find(o => o.id == orgaoId);
            if (orgaoObj) {
                this.filters.orgao = orgaoObj;
            }
        }
    }

    ajustarContratoSelecionado(){
        const contratoId = localStorage.getItem('contratoSelecionado');
        if (contratoId && this.contratos) {
            const contratoObj = this.contratos.find(c => c.id == contratoId);
            if (contratoObj) {
                this.filters.contrato = contratoObj;
            }
        }
    }

    ajustarEquipamentoSelecionado() {
        const equipamentoId = localStorage.getItem('equipamentoSelecionado');
        if (equipamentoId && this.alocacoes) {
            const equipamentoObj = this.alocacoes.find(e => e.id == equipamentoId);
            if (equipamentoObj) {
                this.filters.alocacao = equipamentoObj;
            }
        }
    }

}